import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Doctors from './pages/Doctors';
import DoctorDetail from './pages/DoctorDetail';
import Patients from './pages/Patients';
import PatientDetail from './pages/PatientDetail';
import Appointments from './pages/Appointments';
import AppointmentDetail from './pages/AppointmentDetail';
import Countries from './pages/Countries';

const ProtectedRoute = ({ children }) => {
    const { admin, loading } = useAuth();
    if (loading)
        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100vh',
                    background: '#ffffff',
                }}
            >
                <div className="spinner" />
            </div>
        );
    return admin ? children : <Navigate to="/login" />;
};

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Toaster
                    position="top-right"
                    toastOptions={{
                        style: {
                            background: '#f8f9fa',
                            color: '#1f2937',
                            border: '1px solid #e0e2e7',
                        },
                    }}
                />
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route
                        path="/"
                        element={
                            <ProtectedRoute>
                                <Layout />
                            </ProtectedRoute>
                        }
                    >
                        <Route index element={<Navigate to="/dashboard" />} />
                        <Route path="dashboard" element={<Dashboard />} />
                        <Route path="doctors" element={<Doctors />} />
                        <Route path="doctors/:id" element={<DoctorDetail />} />
                        <Route path="patients" element={<Patients />} />
                        <Route
                            path="patients/:id"
                            element={<PatientDetail />}
                        />
                        <Route path="appointments" element={<Appointments />} />
                        <Route
                            path="appointments/:id"
                            element={<AppointmentDetail />}
                        />
                        <Route path="countries" element={<Countries />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
